import React, { useState, useEffect }  from 'react'
import { Table,  Space } from 'antd'
import Main from '../../../cpn/Main';
import ReportNodeDel from './ReportNodeDel';
import ReportNodeAdd from './ReportNodeAdd';
import ReportNodeCheck from './ReportNodeCheck';
import ReportNodeCopyAdd from './ReportNodeCopyAdd';
import { useTDspjdListQuery } from '../../../store/DianShangYeWuApi';
function ReportNodeList() {
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useTDspjdListQuery({dsbzd_spjd_qy_id:qy_id});
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){            
            // 找出所有不同的dsbzd_spjd_user_id并合并
            const mergedArr = [];
            const userMap = {};
            data.Result.forEach(item => {
                // 用dsbzd_spjd_user_id去合并
                if (item.dsbzd_spjd_user_id && !userMap[item.dsbzd_spjd_user_id]) {
                    userMap[item.dsbzd_spjd_user_id] = {
                        key: item.dsbzd_spjd_user_id,
                        dsbzd_spjd_user_id: item.dsbzd_spjd_user_id,
                        dsbzd_spjd_user_name: item.dsbzd_spjd_user_name,
                        dsbzd_spjd_name: item.dsbzd_spjd_name,
                        dsbzd_spjd_yh_id: item.dsbzd_spjd_yh_id,
                        dsbzd_spjd_yh_name: item.dsbzd_spjd_yh_name,
                        yh_id: item.dsbzd_spjd_yh_id,
                        yh_name: item.dsbzd_spjd_yh_name,
                    }
                    mergedArr.push(userMap[item.dsbzd_spjd_user_id])
                }
            })
            setList(mergedArr);
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '团队报账单操作员',
            dataIndex: 'dsbzd_spjd_user_name',
            key: 'dsbzd_spjd_user_name',
            width: 300, 
            render: (text, record) => <Space>
                <ReportNodeCheck
                    user_id={record.dsbzd_spjd_user_id}
                    user_name={record.dsbzd_spjd_user_name}
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                    dsbzd_spjd_user_id={record.dsbzd_spjd_user_id}
                    dsbzd_spjd_user_name={record.dsbzd_spjd_user_name}
                />
            </Space>
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => <Space size={20}>
                <ReportNodeDel
                    dsbzd_spjd_user_id={record.dsbzd_spjd_user_id}                    
                />
                <ReportNodeCopyAdd
                    dsbzd_spjd_user_id={record.dsbzd_spjd_user_id}  
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Space>
        },
    ]
    return (
        <Main selectedKeys={['/ReportNodeList']}>
            <ReportNodeAdd
                qy_id={qy_id}
                qy_name={qy_name}
                yh_id={yh_id}
                yh_name={yh_name}
            />
            <Table
                columns={columns}
                dataSource={list}
                style={{marginTop:'10px',width:'500px'}}
                className="custom-table"
                size='small'
                bordered
                rowKey="key"
            />
        </Main>
    )
}

export default ReportNodeList